module.exports = __webpack_public_path__ + "img/pagebanner-missions.3e593178.jpg";